export interface ReleaseNote {
    /** Must be unique per release; users who dismissed this id will not see the popup again. */
    id: string;
    title: string;
    /** Short text shown on the popup card. */
    summary: string;
    /** Full content shown when the card is opened. Basic HTML is allowed. */
    content: string;
    date: string;
    /** Optional cover image path, e.g. 'assets/common/images/release-notes/2026-10.png'. */
    image?: string;
    author?: string;
}

// The first entry is shown as the popup. Add new releases at the top.
export const RELEASE_NOTES: ReleaseNote[] = [
    {
        id: '2026-10-14',
        title: "What's new in In Time PRO",
        summary: 'Timesheet reports, sign-in, and several tracking fixes are included in this release.',
        content: `
            <h4>Tasks resolved</h4>
            <ul>
                <li><strong>41296</strong> Timesheet reports can be generated as Excel files and uploaded to blob storage.</li>
                <li><strong>58247</strong> Web login now returns an impersonation token instead of a JWT token.</li>
                <li><strong>58255</strong> Session timeout now asks the user to sign in again.</li>
                <li><strong>58340</strong> Web app service proxy code has been corrected.</li>
            </ul>
            <h4>Bugs fixed</h4>
            <ul>
                <li><strong>41301</strong> Exported report files are available for download again.</li>
                <li><strong>41363</strong> The agent app version is displayed correctly.</li>
                <li><strong>57993</strong> Arrival time now matches between the web and agent applications.</li>
                <li><strong>41424</strong> Active time summary no longer fails for Pacific Time users.</li>
                <li><strong>57124</strong> Cancelling a user import clears the selected file.</li>
                <li><strong>58143</strong> Location lookup now resolves latitude and longitude for an address.</li>
                <li><strong>58234</strong> Daily minimum and maximum hours are validated correctly.</li>
                <li><strong>58240</strong> The cancel button no longer overlaps the content behind it.</li>
                <li><strong>58318</strong> The active project name appears in real-time tracking.</li>
                <li><strong>58462</strong> Employee email verification no longer stays on the loading screen.</li>
            </ul>
        `,
        date: 'October 14, 2026',
        author: 'In Time PRO Team'
    }
];
